// Presentation only: never change catalogue identifiers, prices or order names.
export const productDisplayName = (product = {}, language = "english") =>
  String((language === "arabic" && product.ar_name) || product.name || "")
    .replace(/\s+/g, " ").trim();

export const productDetailsAction = (product = {}, language = "english") => {
  const dimensions = product.variant_values || product.variants || [];
  const size = /^(size|الحجم|المقاس)$/i.test(product.primary_variant_key || product.variant_summary?.primary_key || "") || (Array.isArray(dimensions) ? dimensions : []).some((dimension) =>
    /^(size|الحجم|المقاس)$/i.test(dimension.variant_key || dimension.name || ""),
  ) || (product.options || []).some((option) =>
    option.is_required && /\bsize\b|الحجم|المقاس/i.test(option.name || option.ar_name || ""),
  );
  return language === "arabic"
    ? size ? "اختر الحجم" : "خصّص طلبك"
    : size ? "Choose size" : "Customize";
};

export const optionDisplayName = (option, language = "english") => {
  const raw = ((language === "arabic" && option.ar_name) || option.name || "").trim();
  if (language === "arabic") return raw || "خيارات المنتج";
  const name = raw.replace(/^your choice of\s*/i, "").replace(/:\s*$/, "").trim();
  return name ? name.charAt(0).toUpperCase() + name.slice(1) : "Your preference";
};

export const optionActionLabel = (option, language = "english") => {
  const name = optionDisplayName(option, language);
  if (language === "arabic") return /الحجم|المقاس/.test(name) ? "اختر الحجم" : "أكمل اختياراتك";
  if (/\bsize\b/i.test(name)) return "Choose size";
  if (/\bdrink\b/i.test(name)) return "Choose a drink";
  if (/\bfries\b/i.test(name)) return "Choose fries";
  return "Choose an option";
};

export const optionGuidance = (option, selected = 0, language = "english") => {
  const minimum = option.is_required ? Math.max(1, Number(option.minimum) || 1) : 0;
  const maximum = Number(option.maximum) || 0;
  const ar = language === "arabic";
  let instruction;
  if (minimum && minimum === maximum) instruction = ar ? minimum === 1 ? "اختر خياراً واحداً" : `اختر ${minimum} خيارات` : minimum === 1 ? "Choose one" : `Choose ${minimum}`;
  else if (minimum && maximum) instruction = ar ? `اختر من ${minimum} إلى ${maximum}` : `Choose ${minimum}–${maximum}`;
  else if (minimum) instruction = ar ? `اختر ${minimum} على الأقل` : `Choose at least ${minimum}`;
  else instruction = maximum ? ar ? `اختياري · حتى ${maximum}` : `Optional · up to ${maximum}` : ar ? "اختياري" : "Optional";
  const remaining = Math.max(0, minimum - selected);
  return {
    instruction,
    remaining,
    progress: remaining ? ar ? `متبقي ${remaining}` : `${remaining} remaining` : selected ? ar ? `تم اختيار ${selected}` : `${selected} selected` : "",
  };
};

// Mirrors the active group/conditional relationship used by PDP validation,
// without mutating selection state or triggering errors while browsing.
export const firstRequiredChoice = (product = {}, selections = {}) => {
  const options = Array.isArray(product.options) ? product.options : [];
  for (const option of options) {
    if (!option.is_required) continue;
    const parent = options.find((item) => item.id === option.condition_parent_option);
    const groups = (option.condition_parent ? parent?.groups : option.groups) || [];
    for (const group of groups.length ? groups : [null]) {
      const key = group ? `${option.id}-${group}` : option.id;
      const parentKey = group ? `${option.condition_parent_option}-${group}` : option.condition_parent_option;
      if (option.condition_parent && !selections[parentKey]?.selectedOptions?.[option.condition_parent]) continue;
      if ((selections[key]?.selected || 0) < Math.max(1, Number(option.minimum) || 1)) return { option, key };
    }
  }
  return null;
};
